<template>
  <div style="width:100%;heigh:100%;" id="dispatch-task">
    <template v-if="showPage == 0">
      <el-card class="table_searchbar">
        <div style="display:flex;margin-bottom: 20px;">
          <div style="margin-right:30px">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">工单号：</span>
              <el-select
                :loading="loading"
                style="max-width: 200px"
                clearable
                :remote-method="query => loadProductionBatchCode(query)"
                v-model="searchForm.businessOrderSplitId"
                filterable
                placeholder="工单号"
                remote
              >
                <el-option v-for="item in productionBatchCodeList" :key="item.splitId" :label="item.productionBatchCode" :value="item.splitId"></el-option>
              </el-select>
            </div>
          </div>

          <div style="margin-right:30px">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">物料编码：</span>
              <el-select :loading="loading" style="max-width: 200px" clearable :remote-method="query => remoteMethod(query)" v-model="searchForm.materialId" filterable placeholder="物料编码" remote>
                <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialCode" :value="item.materialId"></el-option>
              </el-select>
            </div>
          </div>

          <div style="margin-right:30px">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">物料名称：</span>
              <el-select :loading="loading" style="max-width: 200px" clearable :remote-method="query => remoteMethod(query)" v-model="searchForm.materialId" filterable placeholder="物料名称" remote>
                <el-option v-for="item in materialList" :key="item.materialId" :label="item.materialName" :value="item.materialId"></el-option>
              </el-select>
            </div>
          </div>

          <div style="margin-right:30px">
            <div class="" @keydown.enter="btnSearch()">
              <span class="title">工序：</span>
              <el-select
                size="small"
                filterable
                :loading="loading"
                clearable
                :remote-method="query => loadProcedureList(query)"
                remote
                style="max-width:200px;"
                v-model="searchForm.procedureName"
                placeholder="工序"
              >
                <el-option style="max-width: 200px" :title="item" v-for="item in procedureList" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </div>
          </div>

          <div style="width:380px">
            <div style="text-align:right">
              <a style="margin-right: 12px;cursor: pointer;font-size: 12px;" @click="toggleShowMore">
                {{ showMore ? "收起" : "展开" }}
                <i :class="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
              </a>
              <el-button size="mini" type="primary" @click="goDetail">批量完工</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="btnSearch()">查询</el-button>
              <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
            </div>
          </div>
        </div>
        <el-collapse-transition>
          <div v-show="showMore">
            <div style="margin-bottom:20px;display:flex">
              <div style="margin-right:30px">
                <div class="">
                  <span class="title">状态：</span>
                  <el-select clearable size="small" filterable style="max-width:200px;" v-model="searchForm.totalProcessStatus" placeholder="状态">
                    <el-option v-for="item in totalProcessStatusOpt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>

              <div style="margin-right:30px">
                <div class="">
                  <span class="title">机组：</span>
                  <el-select style="max-width:200px;" clearable filterable v-model="searchForm.factoryModelId" size="small" maxlength="16" placeholder="选择机组">
                    <el-option v-for="item in workershopList" :key="item.id" :value="item.id" :label="item.name"></el-option>
                  </el-select>
                </div>
              </div>
              <div style=" margin-right:30px">
                <div class="" @keydown.enter="btnSearch()">
                  <span class="title">订单号：</span>
                  <el-input style="max-width:200px" size="small" v-model="searchForm.orderId" placeholder="订单号"></el-input>
                  <!-- <el-select :loading="loading" style="max-width: 150px"  clearable :remote-method="query=>orderRemoteMethod(query)"   v-model="searchForm.orderId" filterable  placeholder="订单号" remote>
                                        <el-option v-for="item in orderOptions" :key="item.label" :value="item.label" :label="item.label"></el-option>
                                    </el-select> -->
                </div>
              </div>
            </div>
          </div>
        </el-collapse-transition>
      </el-card>
      <el-card class="table-card">
        <el-table :data="tableData" style="width: 100%" class="deviceTable " :row-style="rowClass" @row-click="handleCheckedChange">
          <el-table-column width="44">
            <template slot-scope="scope">
              <el-radio v-model="scope.row.isSelect" :label="true">{{ "" }}</el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="productionBatchCode" label="工单号" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orderCode" label="订单号" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="materialCode" label="物料编码" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="materialName" label="物料名称" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specification" label="物料规格" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="procedureIndex" label="工序号" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="procedureName" label="工序名称" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="planEndTime"
            label="计划完成日期"
            :formatter="(row, column, cellValue, index) => $commonUtil.changeToDate(row, column, cellValue, index, true)"
            min-width="80"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="needAmount" label="需求数量" min-width="60" show-overflow-tooltip></el-table-column>
          <el-table-column prop="orderCount" label="订单需求数量" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="arrangeAmount" label="已派工数量" min-width="70" show-overflow-tooltip></el-table-column>
          <el-table-column prop="lastProcedureAmount" label="前工序完成数量" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column prop="finishAmount" label="已完成数量" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remainingAmount" :formatter="getRemainingAmount" label="剩余数量" min-width="80" show-overflow-tooltip></el-table-column>
          <el-table-column prop="totalProcessStatus" label="状态" :formatter="parseTotalProcessStatus" min-width="60" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" fixed="right" width="120">
            <template slot-scope="scope">
              <el-button type="text" @click="showViewDialog(scope.row)" size="small">查看</el-button>
              <el-button type="text" v-if="scope.row.totalProcessStatus >= 1" @click="showPrint(scope.row)" size="small">打印</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="page" style="margin-bottom:0px" v-if="tableData.length > 0">
          <div class="total_page">
            <span> 共{{ tableTotalPage }}条 8条/页</span>
          </div>
          <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
            <el-pagination :page-size="8" background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"> </el-pagination>
          </div>
        </div>
        <div class="item-warp" :style="tableData.length == 0 ? { marginTop: '10px' } : {}">
          <div class="table-item">
            <el-button size="mini" type="primary" style="margin-bottom:10px" @click="addItem" v-show="showAdd">新增派工</el-button>
            <el-table class="task-list" :maxHeight="230" :data="dispatchList" border @row-click="rowClick" :row-style="selectedHighlight" :row-class-name="selectedClass">
              <el-table-column type="index" label="序号" width="60" show-overflow-tooltip></el-table-column>
              <el-table-column prop="dispatchGroupCode" label="派工单号" min-width="106" show-overflow-tooltip></el-table-column>
              <el-table-column prop="dispatchAmount" label="数量" min-width="80">
                <template slot-scope="scope">
                  <el-input v-if="scope.row.isEdit && selectRowList.length == 1" v-model="scope.row.dispatchAmount" @change="dispatchAmountChange($event, scope.row)"></el-input>
                  <span v-else>{{ scope.row.dispatchAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="planEndTime" label="计划完成时间" min-width="120">
                <template slot-scope="scope">
                  <el-date-picker
                    :picker-options="pickerOptions"
                    style="maxWidth:128px"
                    type="date"
                    v-if="scope.row.isEdit"
                    v-model="scope.row.planEndTime"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                  ></el-date-picker>
                  <span v-else>{{ scope.row.planEndTime }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="planEndTime" label="执行人" min-width="120">
                <template slot-scope="scope">
                  <el-select
                    v-loadmore="userLoadmore"
                    v-if="scope.row.isEdit && scope.row.businessOrderDispatchGroupId <= 0"
                    remote
                    :loading="loading"
                    @visible-change="visibleUserList"
                    :remote-method="query => submitUserSearch(query)"
                    style="maxWidth:128px"
                    clearable
                    v-model="scope.row.userId"
                    filterable
                    placeholder="执行人"
                  >
                    <el-option v-for="item in userList" :key="item.userId" :label="item.userName" :value="item.userId"></el-option>
                  </el-select>
                  <span v-else>{{ scope.row.userName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="planEndTime" label="设备" min-width="120">
                <template slot-scope="scope">
                  <el-select
                    v-if="scope.row.isEdit && scope.row.businessOrderDispatchGroupId <= 0"
                    remote
                    :loading="loading"
                    @visible-change="visibleDeviceList"
                    :remote-method="query => submitDeviceSearch(query)"
                    style="maxWidth:128px"
                    clearable
                    v-model="scope.row.deviceId"
                    filterable
                    placeholder="设备"
                  >
                    <el-option v-for="item in deviceList" :key="item.deviceId" :label="item.deviceCode ? `${item.deviceName}||${item.deviceCode}` : ' '" :value="item.deviceId"></el-option>
                  </el-select>
                  <span v-else>{{ scope.row.deviceCode ? `${scope.row.deviceName}|${scope.row.deviceCode}` : "" }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="finishedAmount" label="状态" min-width="60" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ parsePlanState(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="finishedAmount" label="报工数" min-width="60" show-overflow-tooltip></el-table-column>

              <el-table-column label="操作" min-width="140">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.planState == 0 || scope.row.planState == 4" @click="editItem(scope.row)" size="small">编 辑</el-button>
                  <el-button type="text" v-if="!showSave && scope.row.codeValue" @click="printOrder(scope.row)" size="small">打印</el-button>
                  <el-button type="text" v-if="scope.row.planState == 4" @click="forceFinish(scope.row)" size="small">强制完成</el-button>
                  <el-button calss="btn-del" type="text" v-if="scope.row.businessOrderDispatchGroupId <= 0" @click="deleteItem(scope)" size="small">删 除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="width:100%;text-align:center;margin-top:10px;margin-bottom:30px">
            <el-button type="primary" @click="submitTask(false)" v-if="showSave && permission.btn_businessOrderDispatch_submitDispatch">保 存</el-button>
            <el-button type="primary" v-if="permission.btn_businessOrderDispatch_submitDispatch" @click="submitTask(true)">提 交</el-button>
          </div>
        </div>
      </el-card>

      <el-dialog title="打印派工单" @close="printDialogVisible = false" :visible.sync="printDialogVisible" width="40%" center :close-on-click-modal="false">
        <el-table class="task-list" :data="dispatchPrintList" border @selection-change="selectPrintDataChange">
          <el-table-column width="45" type="selection"></el-table-column>
          <el-table-column prop="dispatchGroupCode" label="派工单号" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="dispatchAmount" label="数量" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="userName" label="人员" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column prop="deviceName" label="设备" min-width="120" show-overflow-tooltip></el-table-column>
        </el-table>
        <div slot="footer" style="margin-top:-30px">
          <el-button @click="printDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitPrint">打 印</el-button>
        </div>
      </el-dialog>

      <el-dialog title="修改数量" center :visible.sync="isShowDialog" width="30%" :close-on-click-modal="false">
        <div style="margin-top:-14px;margin-bottom:26px">
          <el-form ref="form" :model="form" :rules="rules">
            <el-table :data="dataList" stripe>
              <el-table-column label="报工时间" min-width="100" prop="submitTime">
                <template slot-scope="scope">
                  <el-form-item>
                    <span>{{ scope.row.submitTime | showSubmitTime }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="报工数量" prop="submitAmount" min-width="100">
                <template slot-scope="scope">
                  <el-form-item>
                    <span>{{ scope.row.submitAmount }}</span>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="实际数量" prop="actualAmount" min-width="100">
                <template slot-scope="scope">
                  <el-form-item :prop="`dataList[${scope.$index}].actualAmount`" :rules="rules.actualAmount">
                    <el-input v-model="scope.row.actualAmount" :maxlength="9" style="width:80px"></el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button size="small" @click="isShowDialog = false" style="margin-left: 20px;">取 消</el-button>
          <el-button type="primary" size="small" @click="updataCount">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 查看开始 -->
      <el-dialog title="查看派工任务" @close="cancelViewDialog" :visible.sync="viewDialogVisible" :width="W ? '80%' : '80%'" center :close-on-click-modal="false">
        <el-form :model="addForm" :rules="rules" ref="editForm" style="width:100%;" class="add_form view_form">
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="">
                <span class="title">工单号：</span>
                <span class="value">{{ addForm.productionBatchCode }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <span class="title">物料编码：</span>
                <span class="value">{{ addForm.materialCode }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <span class="title">物料名称：</span>
                <span class="value">{{ addForm.materialName }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <span class="title">规格型号：</span>
                <span class="value">{{ addForm.specification }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="6">
              <div class="">
                <span class="title">工序序号：</span>
                <span class="value" style="">{{ addForm.procedureIndex }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <span class="title">工序名称：</span>
                <span class="value" style="">{{ addForm.procedureName }}</span>
              </div>
            </el-col>

            <el-col :span="6">
              <div class="">
                <span class="title">需求数量：</span>
                <span class="value">{{ addForm.needAmount }}</span>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="">
                <span class="title">状态：</span>
                <span class="value">{{ addForm.totalProcessStatus }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-row>
              <el-table class="quality-list" :data="addForm.detailList" style="width: 100%;margin-bottom:-10px; overflow-y: auto;max-height:460px" tooltip-effect="dark">
                <el-table-column prop="dispatchGroupCode" label="派工单号" min-width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="dispatchAmount" label="派工数量" min-width="70" show-overflow-tooltip></el-table-column>
                <el-table-column
                  prop="planEndTime"
                  label="计划完成时间"
                  :formatter="(row, column, cellValue, index) => $commonUtil.changeToDate(row, column, cellValue, index, true)"
                  min-width="110"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="deviceCode" label="设备" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="workerName" label="执行者" min-width="70" show-overflow-tooltip></el-table-column>
                <el-table-column
                  prop="actualStartTime"
                  label="开始时间"
                  :formatter="(row, column, cellValue) => $commonUtil.changeToDate(row, column, cellValue)"
                  min-width="110"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="actualEndTime"
                  label="结束时间"
                  :formatter="(row, column, cellValue) => $commonUtil.changeToDate(row, column, cellValue)"
                  min-width="110"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="qualifiedProcessCount" label="合格数量" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="unqualifiedProcessCount" label="不合格数量" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="spoiledProcessCount" label="报废数量" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column prop="actualFinishedAmount" label="实际完成数量" min-width="80" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-tooltip :content="'' + scope.row.actualFinishedAmount" placement="top">
                      <span style="position: relative;top: 4px;margin-right:0px;width: 41px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;">{{
                        scope.row.actualFinishedAmount
                      }}</span>
                    </el-tooltip>
                    <el-button
                      v-if="permission.btn_productionPlan_updateActualFinishedAmount"
                      icon="el-icon-edit"
                      @click="showUpdataCount(scope.row)"
                      style="position: relative;top: 6px;padding:4px;margin:none;border:none;vertical-align: top;"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="gmtCreate" label="创建时间" :formatter="$commonUtil.changeToDate" min-width="110" show-overflow-tooltip></el-table-column>
              </el-table>
            </el-row>
          </el-row>
        </el-form>
        <span slot="footer" style="margin-top:-10px">
          <!-- <el-button type="primary" @click="cancelViewDialog">确 定</el-button> -->
          <el-button @click="cancelViewDialog">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 查看结束 -->
    </template>

    <template v-if="showPage == 1">
      <CloseDispatchOrder></CloseDispatchOrder>
    </template>
  </div>
</template>

<script>
import CloseDispatchOrder from "./CloseDispatchOrder.vue";
export default {
  name: "DispatchTask",
  components: {
    CloseDispatchOrder
  },
  directives: {
    // 在组件中接受一个 directives 的选项
    loadmore: {
      inserted(el, binding) {
        const dom = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap"); // 获取下拉框元素
        dom.addEventListener("scroll", function() {
          // 监听元素触底
          const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (condition) {
            binding.value();
          }
        });
      }
    }
  },
  data() {
    let vm = this;
    return {
      showMore: false,
      dataList: [],
      form: {
        dataList: []
      },
      isShowDialog: false,
      printData: [],
      dispatchPrintList: [],
      printDialogVisible: false,
      showSave: true,

      deviceDialogVisible: false,
      userName: "",
      webSearchText: "",
      loading: false,
      productionBatchCodeList: [],
      materialList: [],
      procedureList: [],
      selectTaskId: null,
      selectUserId: null,
      selectDeviceId: null,
      selectList: [{ id: 1 }, { id: 2 }],
      fristLoad: false,
      showPage: 0,
      addForm: {
        planDetailTableList: []
      },
      showAdd: true,
      userList: [],
      deviceList: [],
      dispatchList: [],
      tableData: [],
      statusOption: [
        //0-未派工|1-部分派工|2-已派工|3-已完成  0,未排产;1,部分派工;2,已派工;3,部分生产中;4,生产中;5,已完工;6,已关闭
        { label: "未派工", value: 0 },
        { label: "部分派工", value: 1 },
        { label: "已派工", value: 2 },
        { label: "已完成", value: 3 }
      ],
      selectRowList: [],
      selectId: null,
      isDisabled: false,
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        procedureName: "",
        businessOrderSplitId: null,
        materialId: null,
        totalProcessStatus: null,
        factoryModelId: null,
        orderId: "",
        userId: null
      },
      totalProcessStatusOpt: [
        //总工序状态(0,未排产;1,部分派工;2,已派工;3,部分生产中;4,生产中;5,已完工;6,已关闭)
        { label: "未排产", value: 0 },
        { label: "部分派工", value: 1 },
        { label: "已派工", value: 2 },
        { label: "部分生产中", value: 3 },
        { label: "生产中", value: 4 },
        { label: "已完工", value: 5 },
        { label: "已关闭", value: 6 }
      ],
      planStateOpt: [
        //0待执行 1已办结 2-已延期 3-任务保存,并不是提交,4-执行中，5-已关闭，6-已暂停
        { label: "待执行", value: 0 },
        { label: "已办结", value: 1 },
        { label: "已延期", value: 2 },
        { label: "已保存", value: 3 },
        { label: "执行中", value: 4 },
        { label: "已关闭", value: 5 },
        { label: "已暂停", value: 6 }
      ],
      tableTotalPage: 1,
      tableCurrentPage: 1,
      selecTaskRow: {},
      viewDialogVisible: false,
      addForm: {
        detailList: []
      },
      workershopList: [],
      rules: {
        reworkType: [{ required: true, message: "请选择返工路径", trigger: "blur" }],
        technologyId: [{ required: true, message: "请选择返工类型", trigger: "blur" }],
        actualAmount: [
          { required: true, message: "请输入完成数量", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (Number(value) > 0) {
                callback();
              } else {
                callback(new Error("数量必须大于零"));
              }
            },
            trigger: "blur"
          }
        ]
      },
      selectUserList: [],
      factoryModelId: [],
      orderOptions: [],
      permission: JSON.parse(localStorage.getItem("permission")),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 60 * 60 * 24 * 1000;
        }
      }
    };
  },
  mounted: function() {
    this.initTable();
    this.loadProductionBatchCode();
    this.remoteMethod();
    this.loadProcedureList();
    this.loadWorkShopList();
    // this.orderRemoteMethod()
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
  },
  computed: {
    span() {
      return this.W ? 8 : 8;
    }
  },

  filters: {
    showSubmitTime(ev, show) {
      return commonUtils.timestampToDate(ev, show);
    },
    paseRate(ev) {
      ev = Number(ev);
      if (ev || ev == 0) {
        ev.toFixed();
        return ev + "%";
      }
    }
  },
  deactivated: function() {
    console.log("deactivated");
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
    goDetail() {
      this.showPage = 1;
    },
    userLoadmore() {
      log("滚动到底部");
    },
    async orderRemoteMethod(query) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({
        url: "/api/select/listOrder",
        params: {
          orderCode: query
        }
      });
      this.loading = false;
      this.orderOptions = data.filter(item => item.label);
    },
    loadWorkShopList() {
      this.$RequestUtil.get({
        url: "/api/factoryModel/getWorkShopList",
        // type:'sync',
        params: {},
        success: res => {
          if (res.code == 0) {
            this.workershopList = res.data;
          } else {
            this.$message.error(res.msg || res.message);
          }
        }
      });
    },
    getRemainingAmount(row) {
      let remainingAmount = row.needAmount - row.finishAmount;
      if (isNaN(remainingAmount) || remainingAmount < 0) {
        remainingAmount = 0;
      }
      return remainingAmount;
    },

    async submitUserSearch(query) {
      this.loading = true;
      this.userList = await this.loadUserList(query, this.selecTaskRow.procedureName, this.selecTaskRow.userId);
      this.loading = false;
    },

    searchDevice() {
      this.webSearchText = "";
      this.deviceDialogVisible = true;
    },
    visibleUserList(ev) {
      if (!ev) {
        this.submitUserSearch("");
      }
    },
    visibleDeviceList(ev) {
      if (!ev) {
        this.submitDeviceSearch("");
      }
    },
    async submitDeviceSearch(query) {
      this.loading = true;
      this.deviceList = await this.loadDeviceList(query, this.selecTaskRow.procedureName, this.selecTaskRow.deviceId);
      this.loading = false;
    },

    selectedHighlight({ row, rowIndex }) {
      if (this.selectId == row.businessOrderDispatchGroupId) {
        return {
          "background-color": "#409EFF",
          color: "#fff",
          cursor: "pointer"
        };
      }
      return { cursor: "pointer" };
    },

    async rowClick(row, column, event) {
      let old = this.selectId;
      this.selectId = row.businessOrderDispatchGroupId;
      this.selectUserId = row.userId;
      this.selectDeviceId = row.deviceId;
      if (row.dispatchGroupStatus == 0) {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }

      this.selecTaskRow = row;
      if (column && column.label != "操作") {
        this.editItem(row);
      }

      // if(old != this.selectId){
      this.userList = await this.loadUserList("", row.procedureName, row.userId);
      this.deviceList = await this.loadDeviceList("", row.procedureName, row.deviceId);
      // }
    },

    addItem() {
      if (this.selectRowList.length == 0) {
        this.$message.warning("请先选择工单");
        return;
      }

      let list = this.dispatchList.map(item => item.dispatchGroupCode);
      let dispatchGroupCode = this.createRandom(this.selectRowList[0].dispatchCode, list);
      let json = {
        dispatchGroupStatus: 0,
        businessOrderDispatchGroupId: -Math.random(),
        procedureName: this.selectRowList[0].procedureName,
        dispatchGroupCode,
        isEdit: true
      };
      if (this.selectRowList.length > 1) {
        let total = 0;
        this.selectRowList.forEach(item => {
          total += item.needAmount;
        });
        json.dispatchAmount = total;
      }
      this.dispatchList.push(json);
      this.rowClick(json);
      this.showAdd = false;
    },

    deleteItem(scope) {
      let index = scope.$index;
      this.dispatchList.splice(index, 1);
      this.showAdd = true;
    },

    selectedClass({ row, rowIndex }) {
      if (this.selectId == row.businessOrderDispatchGroupId) {
        return "select-row";
      } else {
        return "";
      }
    },

    rowClass({ row, columnIndex }) {
      if (row.isSelect) {
        return { "background-color": "rgb(109, 183, 238)", cursor: "pointer" };
      } else {
        return { cursor: "pointer" };
      }
    },

    async handleCheckedChange(row) {
      this.tableData.forEach(item => {
        if (item.id != row.id) {
          item.isSelect = false;
        } else {
          item.isSelect = true;
        }
      });
      this.showAdd = true;
      let idList = this.tableData.filter(item => item.isSelect).map(item => item.id);
      if (idList.length > 0) {
        this.selectRowList = this.tableData.filter(item => item.isSelect);
        let data = await this.loadOrderDispatchGroup(idList);
        data.forEach(item => {
          if (item.planEndTime) {
            item.planEndTime = commonUtils.timestampToDate(item.planEndTime, true);
          }
          item.procedureName = this.selectRowList[0].procedureName;
          let dispatchAmount = item.dispatchAmount;
          if (item.productionCycle && dispatchAmount && dispatchAmount > 0) {
            item.consumeTime = commonUtils.secondToDate(parseInt(dispatchAmount * item.productionCycle + item.prepareTime * 60 * 60));
          } else {
            item.consumeTime = null;
          }
        });
        if (this.selectRowList[0].totalProcessStatus == 0) {
          this.showSave = true;
        } else {
          this.showSave = false;
        }
        this.dispatchList = data;
      } else {
        this.selectRowList = [];
        this.dispatchList = [];
        this.userList = [];
        this.deviceList = [];
        this.showSave = true;
      }
    },

    async loadOrderDispatchGroup(idList) {
      let { data, code, message, msg } = await this.$RequestUtil.postAsync({ url: "/api/businessOrderDispatch/getBusinessOrderDispatchGroup", type: "sync", params: { idList } });
      return data;
    },

    editItem(rowData) {
      if (rowData.planState != 1 && rowData.planState != 5) {
        this.$set(rowData, "isEdit", true);
      }
      this.dispatchList.forEach(item => {
        if (item.isEdit && item.businessOrderDispatchGroupId != rowData.businessOrderDispatchGroupId) {
          this.$set(item, "isEdit", false);
        }
      });
    },

    dispatchAmountChange(ev, row) {
      if (ev && ev > 0) {
        if (row.productionCycle) {
          row.consumeTime = commonUtils.secondToDate(parseInt(Number(ev) * row.productionCycle + row.prepareTime * 60 * 60));
        } else {
          row.consumeTime = null;
        }
      }
    },

    //2生成随机数
    createRandom(prefix, list) {
      let min = 0,
        max = 99;
      let str = parseInt(Math.random() * (max - min + 1) + min) >= 9 ? "" + parseInt(Math.random() * (max - min + 1) + min) : "0" + parseInt(Math.random() * (max - min + 1) + min);
      while (list.includes(prefix + str)) {
        str = parseInt(Math.random() * (max - min + 1) + min) >= 9 ? "" + parseInt(Math.random() * (max - min + 1) + min) : "0" + parseInt(Math.random() * (max - min + 1) + min);
      }
      return prefix + str;
    },

    submitTask(hasSubmit) {
      let dataList = [];

      // if(hasSubmit){

      //提交校验
      //0. 每项派工数量dispatchAmount必须存在并且大于零
      //1. 每项派工数量dispatchAmount必须大于或者等于已报工数量finishedAmount
      //2. 每项派工数量dispatchAmount之和不能大于需求数量 this.selectRowList[0].needAmount
      //3. 每项人userId和设备deviceId必须选择一个
      let isPass = true;
      let err_msg = "";
      let tatol = 0;
      for (let i = 0; i < this.dispatchList.length; i++) {
        let item = this.dispatchList[i];
        let dispatchAmount = Number(item.dispatchAmount);
        if (isNaN(dispatchAmount) || (dispatchAmount <= 0 && item.planState != 1)) {
          err_msg = `派工单号:${item.dispatchGroupCode}的派工数量必须为数字并且大于零`;
          isPass = false;
          break;
        }
        // if(item.finishedAmount&&dispatchAmount<item.finishedAmount){
        //     err_msg = `派工单号:${item.dispatchGroupCode}的派工数量必须为数字(${dispatchAmount})不能小于已报工数量(${item.finishedAmount})`
        //     isPass = false
        //     break
        // }

        if (!item.userId && !item.deviceId) {
          err_msg = `派工单号:${item.dispatchGroupCode}的设备和人不能都为空`;
          isPass = false;
          break;
        }
        tatol += dispatchAmount;
      }
      if (this.selectRowList.length == 1) {
        if (tatol > this.selectRowList[0].needAmount) {
          // err_msg = `派工单派工总数量(${tatol})不能大于工单需求数量(${this.selectRowList[0].needAmount})`
          err_msg = `派工数量>需求数量，请重新填写`;
          isPass = false;
        }
      }

      if (!isPass) {
        this.$message.error(err_msg);
        return;
      }

      // }
      let dispatchList = commonUtils.cloneObj(this.dispatchList);
      if (this.selectRowList.length == 1) {
        this.selectRowList.forEach(item => {
          let subList = [];
          dispatchList.forEach(d => {
            if (d.businessOrderDispatchGroupId < 0) {
              d.businessOrderDispatchGroupId = null;
            }
            if (d.planEndTime) {
              d.planEndTime = d.planEndTime + " 00:00:00";
            }
            subList.push(d);
          });

          dataList.push({
            businessOrderDispatchId: item.id,
            detailList: subList
          });
        });
      } else {
        let list = [];
        this.selectRowList.forEach((item, index) => {
          let subList = [];
          let d = commonUtils.cloneObj(this.dispatchList[0]);
          if (d.businessOrderDispatchGroupId < 0) {
            d.businessOrderDispatchGroupId = null;
          }
          if (d.planEndTime) {
            d.planEndTime = d.planEndTime + " 00:00:00";
          }
          d.dispatchAmount = item.needAmount;
          subList.push(d);
          if (index != 0) {
            d.dispatchGroupCode = this.createRandom(this.selectRowList[0].dispatchCode, list);
          }
          list.push(d.dispatchGroupCode);
          dataList.push({
            businessOrderDispatchId: item.id,
            detailList: subList
          });
        });
      }
      let params = {
        dataList,
        hasSubmit
      };
      this.$RequestUtil.post({
        url: "/api/businessOrderDispatch/submitDispatch",
        type: "sync",
        params,
        success: res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.$message.success("提交成功");
            this.search(this.resetData);
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    async showUpdataCount(rowData) {
      this.form.planId = rowData.planId;
      let {
        data: { dataList },
        code,
        msg,
        message
      } = await this.$RequestUtil.getAsync({ url: "/api/productionPlan/listSubmit", type: "sync", params: { planId: this.form.planId } });
      if (code == 0) {
        this.dataList = dataList;
        this.form.dataList = dataList;
        this.isShowDialog = true;
      } else {
        this.$message.error(message || msg);
      }
    },

    updataCount() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          let dataList = this.dataList.map(item => {
            return { id: item.id, actualAmount: item.actualAmount };
          });
          this.$RequestUtil.post({
            url: "/api/productionPlan/updateActualFinishedAmount",
            type: "sync",
            params: {
              planId: this.form.planId,
              dataList
            },
            success: async res => {
              if (res.code == 0) {
                this.$message.success("修改成功");
                let data = await this.loadDetail(this.addForm.pId);
                this.addForm.detailList = data.detailList;
                this.addForm.totalProcessStatus = this.parseTotalProcessStatus(data);
                this.isShowDialog = false;
              } else {
                this.$message.error(res.message || res.msg);
              }
            }
          });
        }
      });
    },

    resetData() {
      this.selecTaskRow = {};
      this.selectDeviceId = null;
      this.selectUserId = null;
      this.selectId = null;
      let row = this.selectRowList[0];
      this.showAdd = true;
      if (row) {
        this.tableData.forEach(item => {
          if (item.id == row.id) {
            item.isSelect = true;
          }
        });
        this.handleCheckedChange(row);
      }
    },

    async loadDetail(id) {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/businessOrderDispatch/getBusinessOrderDispatch", type: "async", params: { id } });
      return data;
    },

    async loadProductionBatchCode(productionBatchCode) {
      this.loading = true;
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({ url: "/api/select/listProductionBatchCode", type: "async", params: { productionBatchCode } });
      this.productionBatchCodeList = data;
      this.loading = false;
    },

    async remoteMethod(materialCode, materialName) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/selectMaterial", type: "sync", params: { materialCode, materialName } });
      this.materialList = data;
      this.loading = false;
    },

    async loadProcedureList(procedureName) {
      this.loading = true;
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listProcedure", type: "sync", params: { procedureName } });
      this.procedureList = data;
      this.loading = false;
    },

    userSelect(ev, row) {
      this.selecTaskRow.userId = row.userId;
    },

    deviceSelect(ev, row) {
      this.selecTaskRow.deviceId = row.deviceId;
      this.selecTaskRow.productionCycle = row.productionCycle;
      this.selecTaskRow.prepareTime = row.prepareTime;
      let dispatchAmount = this.selecTaskRow.dispatchAmount;
      if (row.productionCycle && dispatchAmount && dispatchAmount > 0) {
        row.consumeTime = commonUtils.secondToDate(parseInt(dispatchAmount * row.productionCycle + row.prepareTime * 60 * 60));
      } else {
        row.consumeTime = null;
      }
      this.$set(this.selecTaskRow, "consumeTime", row.consumeTime);
    },

    async loadUserList(userName, procedureName, includeId) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/businessOrderDispatch/getUserList", params: { userName, procedureName, includeId } });
      return data;
    },

    async loadDeviceList(webSearchText, procedureName, includeId, businessOrderDispatchId) {
      if (this.selectRowList[0]) {
        businessOrderDispatchId = this.selectRowList[0].id;
      }
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/businessOrderDispatch/getDeviceList", params: { webSearchText, procedureName, includeId, businessOrderDispatchId } });
      return data;
    },

    async showViewDialog(rowData) {
      this.addForm = await this.loadDetail(rowData.id);
      this.addForm.totalProcessStatus = rowData.totalProcessStatus;
      this.addForm.pId = rowData.id;
      this.addForm.totalProcessStatus = this.parseTotalProcessStatus(this.addForm);
      this.viewDialogVisible = true;
    },

    // parseTotalProcessStatus(rowData){
    //     return (this.statusOption.find(item=>item.value==rowData.totalProcessStatus)||{}).label
    // },
    parseTotalProcessStatus(rowData) {
      return (this.totalProcessStatusOpt.find(item => item.value == rowData.totalProcessStatus) || {}).label;
    },

    parsePlanState(rowData) {
      return (this.planStateOpt.find(item => item.value == rowData.planState) || {}).label;
    },
    async printOrder(rowData) {
      rowData.productionBatchCode = this.selectRowList[0].productionBatchCode;
      localStorage.setItem("printDispatchTask", JSON.stringify([rowData]));
      let routeUrl = this.$router.resolve({ path: "/Print/printDispatchTask" });
      window.open(routeUrl.href, "_blank");
    },
    submitPrint() {
      if (this.printData.length == 0) {
        this.$message.warning("请选选择需要打印的派工单");
        return;
      }
      localStorage.setItem("printDispatchTask", JSON.stringify(this.printData));
      let routeUrl = this.$router.resolve({ path: "/Print/printDispatchTask" });
      window.open(routeUrl.href, "_blank");
    },

    async showPrint(row) {
      let data = await this.loadOrderDispatchGroup([row.id]);
      data.forEach(item => {
        item.productionBatchCode = row.productionBatchCode;
        item.procedureName = row.procedureName;
        if (item.planEndTime) {
          item.planEndTime = commonUtils.timestampToDate(item.planEndTime, true);
        }
      });

      this.dispatchPrintList = data;
      this.printDialogVisible = true;
    },

    selectPrintDataChange(ev) {
      this.printData = ev;
    },

    cancelViewDialog() {
      this.viewDialogVisible = false;
      this.addForm = {};
    },

    btnSearch: function() {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.businessOrderSplitId = null;
      form.procedureName = "";
      form.materialId = null;
      form.totalProcessStatus = null;
      form.materialId = null;
      form.factoryModelId = null;
      form.userId = null;
      form.orderId = "";
      this.tableData.forEach(item => {
        if (item.totalProcessStatus == 3) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        item.isSelect = false;
      });
      this.selectRowList = [];
      this.dispatchList = [];
      this.userList = [];
      this.deviceList = [];
      this.showSave = true;
      this.showAdd = true;
    },

    search: function(fn, id) {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            procedureName: "",
            businessOrderSplitId: null,
            materialId: null,
            totalProcessStatus: null,
            factoryModelId: null,
            orderId: "",
            userId: null
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/businessOrderDispatch/listBusinessOrderDispatch",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 8,
          businessOrderSplitId: temp.businessOrderSplitId,
          procedureName: temp.procedureName,
          materialId: temp.materialId,
          totalProcessStatus: temp.totalProcessStatus,
          factoryModelId: temp.factoryModelId,
          // userId:temp.userId,
          orderCode: temp.orderId
        },
        success: async res => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            res.data.forEach(item => {
              item.isSelect = false;
              if (item.totalProcessStatus == 3) {
                item.disabled = true;
              } else {
                item.disabled = false;
              }
            });
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
            if (fn) {
              if (fn) {
                if (id) {
                  let data = await fn(id);
                  data.forEach(item => {
                    if (item.planEndTime) {
                      item.planEndTime = commonUtils.timestampToDate(item.planEndTime, true);
                    }
                    item.procedureName = this.selectRowList[0].procedureName;
                    let dispatchAmount = item.dispatchAmount;
                    if (item.productionCycle && dispatchAmount && dispatchAmount > 0) {
                      item.consumeTime = commonUtils.secondToDate(parseInt(dispatchAmount * item.productionCycle + item.prepareTime * 60 * 60));
                    } else {
                      item.consumeTime = null;
                    }
                  });
                  this.tableData.forEach(item => {
                    if (item.id == id[0]) {
                      item.isSelect = true;
                    }
                  });
                  if (this.selectRowList[0].totalProcessStatus == 0) {
                    this.showSave = true;
                  } else {
                    this.showSave = false;
                  }
                  this.dispatchList = data;
                  if (data.length == 0) {
                    this.showAdd = true;
                  }
                } else {
                  fn();
                }
              }
              fn && fn(id);
            } else {
              this.selectRowList = [];
              this.dispatchList = [];
              this.userList = [];
              this.deviceList = [];
              this.showSave = true;
              this.showAdd = true;
            }
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    pageChange: function(targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },

    initTable: function() {
      this.search();
    },

    parseDate: function(rowData) {
      if (rowData.gmtCreate != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtCreate, true);
        return dateString;
      }
    },
    forceFinish: function(rowData) {
      this.$confirm(`强制完成后，剩余没报工的数量将会返回到总工序的需求数量，是否继续?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/productionPlan/forceFinish",
          type: "sync",
          params: {
            dispatchGroupId: rowData.businessOrderDispatchGroupId
          },
          success: res => {
            if (res.code == 0) {
              let ids = this.tableData.filter(item => item.isSelect).map(item => item.id);
              this.search(this.loadOrderDispatchGroup, ids);
              this.$message.success("强制完成任务");
            } else {
              this.$message.error(res.msg || res.message);
            }
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.item-warp {
  /* display: flex; */
  width: 100%;
  margin-top: -16px;
  display: grid;
  grid-column-gap: 20px;
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.table-item {
  flex: 1;
  /* margin-right: 20px; */
}

.dialog-footer {
  margin-top: -20px;
}

.delete {
  width: 18px;
  height: 19px;
  background-image: url("/static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}

.delete:hover {
  background-image: url("/static/img/del-hover.png");
  background-repeat: no-repeat;
}

.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  width: 70px;
  text-align: right;
  display: inline-block;
}

.add_form .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}
.view_form .title {
  text-align: left;
  width: auto;
}
.add_form .value {
  display: inline-block;
}

.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}

.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}

.el-textarea .el-input__count {
  line-height: 12px;
}

#dispatch-task .task-list .el-table__body tr:hover > td,
#dispatch-task .task-list .el-table__body tr:hover > td .el-button--text {
  color: #fff;
  background-color: #409eff;
}

#dispatch-task .task-list .select-row .el-button--text {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/order/DispatchTask/index.vue